import type { CatalogFeatureGroup } from '../types.js';

/**
 * SEED DATA — not runtime config. `FEATURE_GROUPS` is the code-owned catalog that
 * POPULATES the `iam_feature_groups` read-model, and it is written to the DB from
 * exactly two places: the backfill migration (existing tenants) and
 * `PermissionService.provisionTenant` (a newly created company). It is never read
 * to render the UI — the permission-set editor's blueprint always comes from the
 * DB via `getBlueprint(tenantId)`. Change a group here AND ship a migration to
 * update already-provisioned tenants; editing this list alone changes nothing for
 * existing companies.
 */

/** Feature-group keys — each resource declares which group it belongs to. */
export const FEATURE_GROUP_KEYS = {
  COMPANY_MANAGEMENT: 'company-management',
  NETWORK: 'network',
  PRODUCTS: 'products',
  VENDOR_COMPLIANCE: 'vendor-compliance',
  TRACEABILITY: 'traceability',
  RISK_MANAGEMENT: 'risk-management',
  REPORTS: 'reports',
} as const;

/** The UI groupings shown in the permission-set editor's left nav, in order. */
export const FEATURE_GROUPS: readonly CatalogFeatureGroup[] = [
  {
    key: FEATURE_GROUP_KEYS.NETWORK,
    name: 'Network',
    description: 'Supplier and partner directory',
    order: 1,
  },
  {
    key: FEATURE_GROUP_KEYS.PRODUCTS,
    name: 'Products',
    description: 'Style, article and product master data',
    order: 2,
  },
  {
    key: FEATURE_GROUP_KEYS.VENDOR_COMPLIANCE,
    name: 'Vendor Compliance',
    description: 'Assessments, certificates, audits and corrective actions',
    order: 3,
  },
  {
    key: FEATURE_GROUP_KEYS.TRACEABILITY,
    name: 'Traceability',
    description: 'Orders, supply chain mapping and material balances',
    order: 4,
  },
  {
    key: FEATURE_GROUP_KEYS.RISK_MANAGEMENT,
    name: 'Risk Management',
    description: 'Risk assessment and monitoring',
    order: 5,
  },
  {
    key: FEATURE_GROUP_KEYS.REPORTS,
    name: 'Reports',
    description: 'Analytics and exports',
    order: 6,
  },
  {
    key: FEATURE_GROUP_KEYS.COMPANY_MANAGEMENT,
    name: 'Company Management',
    description: 'Team members, roles and access',
    order: 7,
  },
];
